export type RuntimePaths = {
  apiRoot: string;
  publicSite: string;
};

const cleanPath = (value: string) => value.replace(/\/+$/, '');

export function resolveRuntimePaths(baseUri: string): RuntimePaths {
  const portalRoot = new URL('./', baseUri);
  const apiRoot = cleanPath(new URL('../api/v1/', portalRoot).pathname);
  return {
    apiRoot,
    publicSite: new URL('../', portalRoot).pathname,
  };
}

const runtimeBaseUri = typeof document === 'undefined'
  ? 'http://localhost/portal-next/'
  : document.baseURI;

export const runtimePaths = resolveRuntimePaths(runtimeBaseUri);
